export default __webpack_public_path__ + "static/media/ic_belarus.ad3ab386.svg";